module.exports = __webpack_public_path__ + "static/media/cinthya.7436b607.bin";